import { useEffect, useState } from 'react'
import { Sparkles } from 'lucide-react'
import { publicApi } from '../../services/publicApi'
import BookCard from './BookCard'

const NewReleasesFeed = () => {
  const [list, setList] = useState(null)
  const [status, setStatus] = useState('loading') // loading | ready | error

  useEffect(() => {
    let active = true
    publicApi
      .getNewReleases({ limit: 12 })
      .then((data) => {
        if (!active) return
        setList(data)
        setStatus('ready')
      })
      .catch(() => {
        if (active) setStatus('error')
      })

    return () => {
      active = false
    }
  }, [])

  useEffect(() => {
    if (window.location.hash !== '#new-releases') return

    const focusNewReleases = () => {
      const section = document.getElementById('new-releases')
      if (!section) return
      section.scrollIntoView({ block: 'start' })
      section.focus({ preventScroll: true })
    }

    window.requestAnimationFrame(focusNewReleases)
  }, [])

  const books = Array.isArray(list?.books) ? list.books : []
  const isEmpty = status === 'ready' && books.length === 0

  return (
    <section id="new-releases" tabIndex={-1} className="scroll-mt-24 bg-bg-main py-12 outline-none lg:py-16">
      <div className="container-custom">
        <div className="mb-8 rounded-lg border border-primary-100 bg-primary-50 p-5 sm:p-6">
          <p className="text-sm font-bold uppercase text-primary-700">Fresh from the app</p>
          <h2 className="mt-2 text-2xl font-extrabold text-text-primary sm:text-3xl">
            New Releases
          </h2>
        </div>

        {(status === 'error' || isEmpty) && (
          <div className="rounded-lg border border-gray-100 bg-bg-surface py-16 text-center text-text-secondary shadow-soft">
            {status === 'error'
              ? 'Could not load New Releases right now. Please try again in a moment.'
              : 'No new releases are available yet. Check back soon.'}
          </div>
        )}

        {status === 'loading' ? (
          <div className="rounded-lg border border-gray-100 bg-bg-surface p-5 shadow-soft">
            <div className="mb-5 flex items-center gap-2">
              <div className="h-7 w-7 animate-pulse rounded-lg bg-bg-soft" />
              <div className="h-5 w-40 animate-pulse rounded bg-bg-soft" />
            </div>
            <div className="flex gap-4 overflow-hidden">
              {[0, 1, 2, 3, 4, 5].map((item) => (
                <div key={item} className="h-56 w-36 shrink-0 animate-pulse rounded-lg bg-bg-soft" />
              ))}
            </div>
          </div>
        ) : (
          books.length > 0 && (
            <section className="rounded-lg border border-gray-100 bg-bg-surface p-4 shadow-soft sm:p-5">
              <div className="mb-5 flex items-center gap-2 text-xs font-bold uppercase text-primary-700">
                <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-50">
                  <Sparkles size={16} />
                </span>
                By Bukito
              </div>
              <div className="-mx-1 flex gap-4 overflow-x-auto px-1 pb-2 no-scrollbar">
                {books.map((book) => (
                  <BookCard
                    key={book.id ?? book.isbn13}
                    book={book}
                    linkState={{ backTo: { pathname: '/', hash: '#new-releases' } }}
                  />
                ))}
              </div>
            </section>
          )
        )}
      </div>
    </section>
  )
}

export default NewReleasesFeed
